import { InjectionToken } from '@angular/core';
import { JobParentType } from '../../state/job-parent';

export const JOB_PARENT_TYPE = new InjectionToken<JobParentType>('Job Parent Type');
